import type { SetAccountModeRequest } from '@patrianna/shared-patrianna-types/websocket/requests'
import type { SetAccountModeResponse } from '@patrianna/shared-patrianna-types/websocket/response'
import cx from 'classnames'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import CopyToClipboardInput from 'components/CopyToClipboardInput'
import ROUTES from 'config/routes.json'
import { serviceDependencies } from 'src/services'
import { useAppDispatch } from 'src/store/hooks'
import { setDataToLocalStorage } from 'src/utils/localStorage'
import { accountModeChangedHandler } from 'store/modules/user/actions'

import classes from './styles.module.scss'

type Props = {
  isLoggedIn: boolean
  isSCenabled: boolean
  fbBrowser: boolean
}

export default function ActivateSCMode(props: Props) {
  const dispatch = useAppDispatch()
  const router = useRouter()

  useEffect(() => {
    dispatch(setDataToLocalStorage('QUERY', 'utm_campaign=internal-campaign-sweepstake-mode', false))

    if (!props.isLoggedIn) {
      router.push(ROUTES.REGISTER)
    } else if (props.isLoggedIn && !props.isSCenabled) {
      const data: SetAccountModeRequest = {
        type: 'SetAccountModeRequest',
        mode: 'sweepstake',
      }

      serviceDependencies.gateway
        .emit<SetAccountModeResponse>(data)
        .then((body) => {
          dispatch(accountModeChangedHandler(body))
        })
        .catch((err) => {
          dispatch(serviceDependencies.errorHandler(err, data))
        })
    }

    router.replace(ROUTES.HOME)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isLoggedIn, props.isSCenabled])

  if (props.fbBrowser) {
    return (
      <div className={cx(classes.root, 'mt-paper')}>
        <img src={`${process.env.IMG_ORIGIN}/invite-friends-sc.jpg`} width={150} alt='invite friends banner' />

        <h4 className={classes.title}>
          Please open a non-Facebook browser (Safari, Chrome etc) and paste this link to activate SC
        </h4>

        <CopyToClipboardInput inputText={document.URL} />
      </div>
    )
  }

  return null
}
